const Lamp = (props) => (
  <svg width='13.068' height='18.641' viewBox='0 0 13.068 18.641' fill='#fff' {...props}>
    <path d='M3.737,17.7a.933.933,0,0,0,.94.94H8.392a.933.933,0,0,0,.94-.94v-.918H3.737ZM6.534,0A6.361,6.361,0,0,0,3.988.514,6.54,6.54,0,0,0,.514,3.988,6.307,6.307,0,0,0,0,6.512a6.335,6.335,0,0,0,.765,3.07A6.479,6.479,0,0,0,2.8,11.866V14.9a.933.933,0,0,0,.94.94H9.331a.933.933,0,0,0,.94-.94V11.866A6.479,6.479,0,0,0,12.3,9.583a6.335,6.335,0,0,0,.765-3.07,6.307,6.307,0,0,0-.514-2.524A6.54,6.54,0,0,0,9.08.514,6.361,6.361,0,0,0,6.534,0Z' />
  </svg>
)

export default Lamp
